import { Link, useLocation } from 'react-router';
import { useCallback, useState, useEffect } from 'react';
import { NAV_PATH, ROUTER_PATH } from '@/router/constants';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Remote } from '@/api/remote';
import { ApiConstant } from '@/constants/api_constants';
import { Constants } from '@/constants/constants';

import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { UiCommon } from '@/common/common';
import { useStartPopup } from '@/hooks/useStartPopup';

interface Slide {
	link: string;
	src: string;
	alt: string;
	target: string;
}

const HeaderGroup = () => {
	const [banner, setBanner] = useState<Slide[]>([]);
	const { openStartPopup } = useStartPopup();

	// Active 클래스 추가 로직
	const { pathname } = useLocation();
	const isActive = useCallback(
		(path: string | string[]) => {
			if (typeof path === 'string') {
				if (pathname.includes(path)) {
					return 'active';
				} else {
					return '';
				}
			} else {
				const isActive = path.some(p => pathname.includes(p));
				return isActive ? 'active' : '';
			}
		},
		[pathname]
	);

	const getImgSrcFromHtml = (html: string) => {
		const cleaned = html.trim().replace(/^"|"$/g, '');

		const match = cleaned.match(/src=["']([^"']+)["']/i);
		return match ? match[1] : Constants.empty;
	};

	const getSlide = async () => {
		const params = {
			pcOrMo: 'pc'
		};
		const response = await Remote.Api.get(`${ApiConstant.mgmtHomeBnnr.list}`, params);
		if (response.code !== Constants.apiSuccess) {
			setBanner([]);
			return;
		}

		if (response.content.length !== 0) {
			const bannerList: Slide[] = response.content.map((item: any) => {
				return {
					link: item.homeBnnrLinkUrl,
					src: getImgSrcFromHtml(item.homeBnnrPcImg),
					alt: item.homeBnnrNm,
					target: item.urlRedirectType === 'URLRDTP001' ? '_blank' : ''
				};
			});
			setBanner(bannerList);
		}
	};

	useEffect(() => {
		getSlide();
	}, []);

	return (
		<>
			<div className="header-banner">
				<Swiper
					direction="vertical"
					slidesPerView={1}
					loop
					speed={1000}
					autoplay={{
						delay: 5000
					}}
					modules={[Autoplay]}>
					{banner?.map(slide => (
						<SwiperSlide key={slide.src}>
							{slide.link ? (
								<a href={slide.link} target={slide.target}>
									<img src={slide.src} alt={slide.alt} />
								</a>
							) : (
								<img src={slide.src} alt={slide.alt} />
							)}
						</SwiperSlide>
					))}
				</Swiper>
			</div>
			<div className="header-group">
				<div className="header-inner">
					<h1 className="logo-wrap">
						<Link className="logo" to="/" title="Stella logo" aria-hidden="true">
							<span className="blind">홈으로</span>
						</Link>
					</h1>
					<nav id="" className="gnb-wrap">
						<ul className="gnb">
							<li className={`depth1 ${isActive(NAV_PATH.INTRO)}`}>
								<Link to={NAV_PATH.INTRO}>서비스 소개</Link>
							</li>
							<li className={`depth1 ${isActive(Object.values(ROUTER_PATH.FUNCTION))}`}>
								<Link to={NAV_PATH.FUNCTION.MAIN} className="new">
									특별한 기능
								</Link>
								<ul>
									<li className={`depth2 ${isActive(NAV_PATH.FUNCTION.MAIN)}`}>
										<Link to={NAV_PATH.FUNCTION.MAIN}>주요 기능</Link>
									</li>
									<li className={`depth2 ${isActive(NAV_PATH.FUNCTION.CONVENIENCE)}`}>
										<Link to={NAV_PATH.FUNCTION.CONVENIENCE}>편의 기능</Link>
									</li>
								</ul>
							</li>
							<li className={`depth1 ${isActive(NAV_PATH.PRICE)}`}>
								<Link to={NAV_PATH.PRICE}>가격 정책</Link>
							</li>
							<li className={`depth1 ${isActive(NAV_PATH.CONSULTING)}`}>
								<Link to={NAV_PATH.CONSULTING}>전문가문의</Link>
							</li>
							<li className={`depth1 ${isActive(Object.values(ROUTER_PATH.CUSTOMER_SUPPORT))}`}>
								<Link to={NAV_PATH.CUSTOMER_SUPPORT.FAQ}>고객 지원</Link>
								<ul>
									<li className={`depth2 ${isActive(NAV_PATH.CUSTOMER_SUPPORT.NOTICE)}`}>
										<Link to={NAV_PATH.CUSTOMER_SUPPORT.NOTICE}>공지사항</Link>
									</li>
									<li className={`depth2 ${isActive(NAV_PATH.CUSTOMER_SUPPORT.FAQ)}`}>
										<Link to={NAV_PATH.CUSTOMER_SUPPORT.FAQ}>자주 묻는 질문</Link>
									</li>
									{/* <li className={`depth2 ${isActive(NAV_PATH.CUSTOMER_SUPPORT.EVENT)}`}>
									<Link to={NAV_PATH.CUSTOMER_SUPPORT.EVENT}>이벤트</Link>
								</li> */}
								</ul>
							</li>
							<li className={`depth1 ${isActive(Object.values(ROUTER_PATH.INQUIRY))}`}>
								<Link to={NAV_PATH.INQUIRY.SERVICE}>문의하기</Link>
								<ul>
									<li className={`depth2 ${isActive(NAV_PATH.INQUIRY.SERVICE)}`}>
										<Link to={NAV_PATH.INQUIRY.SERVICE}>서비스 문의</Link>
									</li>
									<li className={`depth2 ${isActive(NAV_PATH.INQUIRY.PARTNERSHIP)}`}>
										<Link to={NAV_PATH.INQUIRY.PARTNERSHIP}>제휴 문의</Link>
									</li>
								</ul>
							</li>
						</ul>
					</nav>

					<div className="button-group">
						<button className="btn primary round md" type="button" onClick={openStartPopup}>
							2개월 무료체험하기
						</button>
						<a
							className="btn primary round border md"
							rel="noopener noreferrer"
							target="_blank"
							title="새창 열림"
							onClick={() => UiCommon.goStellaService()}>
							스텔라 로그인
						</a>
					</div>
				</div>
			</div>
		</>
	);
};

export default HeaderGroup;
